import {TrackingStatus} from 'types';
import {
  CompletedBadgeIcon,
  DeliveringBadgeIcon,
  DefaultBadgeIcon,
} from 'pages/Tracking/icons';

type Props = {
  status: TrackingStatus;
};

export const StatusIcon = ({status}: Props) => {
  switch (status) {
    case 'delivering':
      return <DeliveringBadgeIcon />;
    case 'picked_up':
    case 'delivered':
      return <CompletedBadgeIcon />;
    default:
      return <DefaultBadgeIcon />;
  }
};
